__turbopack_context__.v({
  "color-accent": "Tag-module-scss-module__cEPBlq__color-accent",
  "color-error": "Tag-module-scss-module__cEPBlq__color-error",
  "color-primary": "Tag-module-scss-module__cEPBlq__color-primary",
  "color-secondary": "Tag-module-scss-module__cEPBlq__color-secondary",
  "color-soft": "Tag-module-scss-module__cEPBlq__color-soft",
  "color-success": "Tag-module-scss-module__cEPBlq__color-success",
  "icon": "Tag-module-scss-module__cEPBlq__icon",
  "label": "Tag-module-scss-module__cEPBlq__label",
  "remove-button": "Tag-module-scss-module__cEPBlq__remove-button",
  "size-lg": "Tag-module-scss-module__cEPBlq__size-lg",
  "size-md": "Tag-module-scss-module__cEPBlq__size-md",
  "size-sm": "Tag-module-scss-module__cEPBlq__size-sm",
  "tag": "Tag-module-scss-module__cEPBlq__tag",
  "variant-fill": "Tag-module-scss-module__cEPBlq__variant-fill",
  "variant-outlined": "Tag-module-scss-module__cEPBlq__variant-outlined",
});
